import React, {useState, useEffect} from "react";
import {Routes, Route, useNavigate, Link} from 'react-router-dom';
import moment from 'moment';
import { Dropdown, Menu, Space, Table, Tag, Select, Empty, DatePicker, Spin, Tooltip as AntTooltip, Drawer, Segmented, Input, Tabs, Button, Comment, Form, Avatar, List } from 'antd';
import { DollarCircleOutlined, RiseOutlined, FallOutlined, UserOutlined, BankOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Sector, Cell } from 'recharts';

import * as Styled from './style.js';
import { postData,getData } from '../../config/api-connect';
import Spinner from '../../components/spinner'

const { Option } = Select;
const { TextArea } = Input;

const COLORS = ['#04BFB9','#39b351','#4682b4','#bdb76b', '#FF8042'];

const Dashboard = () => {

  var today = new Date();
  var mm = String(today.getMonth() + 1).padStart(2, '0')
  var yyyy = today.getFullYear()
  yyyy = yyyy.toString()

  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  var local_game_type = JSON.parse(localStorage.getItem('gameType'))
  if(!local_game_type){
    local_game_type = 'All'
  }

  const [loading, setLoading] = useState(true)
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [cityId, setCityId] = useState(local_city)
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [venuelist, setVenuelist] = useState([])
  const [month, setMonth] = useState(mm)
  const [year, setYear] = useState(yyyy)
  const [gameType, setGameType] = useState(local_game_type)
  const [revenueSum, setRevenueSum] = useState('')
  const [collectionSum, setCollectionSum] = useState('')
  const [activeSum, setActiveSum] = useState('')
  const [customerDiff, setCustomerDiff] = useState('')
  const [revenueDiff, setRevenueDiff] = useState('')
  const [collectionDiff, setCollectionDiff] = useState('')
  const [graphData, setGraphData] = useState({})
  const [pieGraphData, setpieGraphData] = useState([])
  const [leadCount, setLeadCount] = useState('')
  const [graphLoader, setGraphLoader] = useState(false)
  
  useEffect(() => {
     localStorage.setItem('month', JSON.stringify(month));
     localStorage.setItem('year', JSON.stringify(year));
     localStorage.setItem('selectedVenueId',JSON.stringify(selectedVenueId))
     localStorage.setItem('cityId',JSON.stringify(cityId))
     if(gameType !== 'All') {
       localStorage.setItem('gameType',JSON.stringify(gameType))
     }
  }, [month,year,selectedVenueId,cityId,gameType]);

  useEffect(() => {
     getVenues()
  }, []); 

  useEffect(() => {   
    if(cityId !== ''){
      setLoading(true)
      getDashboardStats()
      getDashboardGraph()
    }
  }, [month,year,selectedVenueId,cityId,gameType]);

  useEffect(() => {
    if(cities.length){
      getVenuesInCity()
    }
  }, [cities,cityId]);

  const handleCityChange = (value) => {
    if (value.length > 0) {
      const last_selected = value[value.length - 1]
      if(last_selected == 'All'){
        setCityId(['All']);
      }
      else{
        const filtered = value.filter(v => v !== 'All');
        setCityId(filtered)
      }
    }
    else {
      setCityId(['All']);
    }
  };

  const getVenuesInCity =() =>{
    if(cities[0] && !cityId){
      setCityId([cities[0].id])
    }

    let filteredVenues;

    if (cityId === 'All' || (Array.isArray(cityId) && cityId.includes('All')) ) {
      filteredVenues = venues;
    } else {
      filteredVenues = Array.isArray(cityId) ? venues.filter(item => cityId.includes(item.city)) : venues ;
    }

    setVenuelist(filteredVenues);
    const venueExists = filteredVenues.some(item => item.id === selectedVenueId);
    if (!venueExists) {
      setSelectedVenueId('All');
    }
  }

  useEffect(()=>{
    if(cityId !== ''){
      setLoading(true)
      getLeadPipelineGraph()
    }
  }, [selectedVenueId,cityId]); 

  const getVenues = async () => {
    await getData('/business/get_venues_for_buddies/')
    .then(response =>{
      setVenues(response.result)
      setCities(response.cities)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  };

  const getDashboardStats = () => {
    getData(`/business/get_business_dashboard/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=${gameType}`)
    .then(response =>{
      setRevenueSum(response.revenue_sum)
      setCollectionSum(response.collection_sum)
      setActiveSum(response.active_customers)
      setCustomerDiff(response.customer_diff)
      setCollectionDiff(response.collection_diff)
      setRevenueDiff(response.revenue_dif)
      setLoading(false)
     })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const getDashboardGraph = () => {
    setGraphLoader(true)
    getData(`/business/get_dashboard_graph/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}&game_type_id=${gameType}`)    .then(response =>{
      setGraphData(response.result)
      setGraphLoader(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const getLeadPipelineGraph = () => {
    getData(`/business/get_hot_leads_graph/?venue_id=${selectedVenueId}&city_id=${cityId}`)
    .then(response =>{
      setpieGraphData(response.result)
      setLeadCount(response.total)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }
 
  return (
    <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>

        <Styled.TopDiv>
          
          <Styled.SelectorContainer>
            {cities.length > 1 &&        
              <Styled.Selector>
                <span className='indicatorText'>City</span>
                <Select
                  mode="multiple"
                  className = 'mainSelector'
                  style={{width: 150}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={handleCityChange}
                  value = {cityId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {
                    cities.map(item=>(
                      <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }

            {venuelist && venuelist.length > 0 &&
              <Styled.Selector>
                <span className='indicatorText'>Venue</span>
                <Select
                  className = 'mainSelector'
                  style={{width: 300}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={setSelectedVenueId}
                  value = {selectedVenueId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {venuelist.map(item=>(
                    <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }

            <Styled.Selector>
              <span className='indicatorText'>Program</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 210}}
                  onChange={setGameType}
                  value = {gameType}
                  bordered={false}
                >
                  <Option value="All">All</Option>
                  <Option value="8"> Football Academy </Option>
                  <Option value="10"> Badminton Academy </Option>
                  <Option value="65"> Swimming Academy </Option>
                  <Option value="44"> Tennis Academy </Option>

                </Select>
            </Styled.Selector>
          </Styled.SelectorContainer>

          <div style={{display: 'flex'}}>
            <Styled.Selector>
            <span className='indicatorText'>Month</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 150}}
                  onChange={setMonth}
                  value = {month}
                  bordered={false}
                >
                  <Option value="12"> December </Option>
                  <Option value="11"> November </Option>
                  <Option value="10"> October </Option>
                  <Option value="09"> September </Option>
                  <Option value="08"> August </Option>
                  <Option value="07"> July </Option>
                  <Option value="06"> June </Option>
                  <Option value="05"> May </Option>
                  <Option value="04"> April </Option>
                  <Option value="03"> March </Option>
                  <Option value="02"> February </Option>
                  <Option value="01"> January </Option>
                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <span className='indicatorText'>Year</span>
              <div className = 'mainSelector' style={{width: 100}}>
                <DatePicker defaultValue={moment(year, 'YYYY')}  onChange = {onChangeYear}  bordered={false}  picker="year" />
              </div>
            </Styled.Selector>
          </div>
        </Styled.TopDiv>

        <Styled.StatsDiv>
        <Link to="/customers">
          <Styled.StatsBox>
            <Styled.IconDiv>
              <UserOutlined style={{fontSize: 'xx-large',color:'#4682b4'}} />
            </Styled.IconDiv>
            <Styled.LabelDiv>
              <Styled.StatsLabel> Active Customers </Styled.StatsLabel>
              <Styled.PieDiv>
                <Styled.AmountLabel> 
                  {
                    activeSum ?
                      activeSum
                    :
                      <span style={{color: 'grey', fontSize: 'small'}}> data not available </span> 
                  }  
                </Styled.AmountLabel>  
                {
                  (customerDiff || customerDiff == 0) &&
                    <Styled.PercentDiv style={{backgroundColor: Math.sign(customerDiff) == '1' ? 'rgb(233 255 232)' : 'rgb(255 232 232)'}}>   
                      {
                        Math.sign(customerDiff) == '1' ?
                          <RiseOutlined  style={{color:  'green'}}/> 
                        :
                          <FallOutlined  style={{color: 'red'}}/>
                      }
                      <div style={{color: Math.sign(customerDiff) == '1' ? 'green' : 'red',paddingLeft:'5px'}}> { Math.abs(customerDiff) + '%'} </div>
                    </Styled.PercentDiv>
                }
              </Styled.PieDiv>
            </Styled.LabelDiv>
          </Styled.StatsBox>
        </Link>

        <Link to="/revenue">
          <Styled.StatsBox>
            <Styled.IconDiv>
              <DollarCircleOutlined style={{fontSize: 'xx-large',color:'#04BFB9'}} />
            </Styled.IconDiv>
            <Styled.LabelDiv>
              <Styled.StatsLabel> Revenue </Styled.StatsLabel>
              <Styled.PieDiv>
                <Styled.AmountLabel> 
                  {
                    revenueSum ?
                      revenueSum.toLocaleString('en-IN')
                    :
                      <span style={{color: 'grey', fontSize: 'small'}}> data not available </span>
                  } 
                </Styled.AmountLabel> 
                {
                  (revenueDiff || revenueDiff == 0) &&
                    <Styled.PercentDiv style={{backgroundColor: Math.sign(revenueDiff) == '1' ? 'rgb(233 255 232)' : 'rgb(255 232 232)'}}>   
                      {
                        Math.sign(revenueDiff) == '1' ?
                          <RiseOutlined  style={{color:  'green'}}/> 
                        :
                          <FallOutlined  style={{color: 'red'}}/>
                      }
                      <div style={{color: Math.sign(revenueDiff) == '1' ? 'green' : 'red',paddingLeft:'5px'}}> { Math.abs(revenueDiff) + '%'} </div>
                    </Styled.PercentDiv>
                } 
              </Styled.PieDiv>
            </Styled.LabelDiv>
          </Styled.StatsBox>
        </Link>
          
        <Link to="/collection">  
          <Styled.StatsBox>
            <Styled.IconDiv>
              <BankOutlined style={{fontSize: 'xx-large',color:'#02475c'}} />
            </Styled.IconDiv>
            <Styled.LabelDiv>
              <Styled.StatsLabel> Collection </Styled.StatsLabel>
              <Styled.PieDiv>
                <Styled.AmountLabel> 
                  {
                    collectionSum ?
                      collectionSum.toLocaleString('en-IN')
                    :
                      <span style={{color: 'grey', fontSize: 'small'}}> data not available </span>
                  }   
                </Styled.AmountLabel>
                {
                  (collectionDiff || collectionDiff == 0) &&
                    <Styled.PercentDiv style={{backgroundColor: Math.sign(collectionDiff) == '1' ? 'rgb(233 255 232)' : 'rgb(255 232 232)'}}>   
                      {
                        Math.sign(collectionDiff) == '1' ?
                          <RiseOutlined  style={{color:  'green'}}/> 
                        :
                          <FallOutlined  style={{color: 'red'}}/>
                      }
                      <div style={{color: Math.sign(collectionDiff) == '1' ? 'green' : 'red',paddingLeft:'5px'}}> { Math.abs(collectionDiff) + '%'} </div>
                    </Styled.PercentDiv>
                }
              </Styled.PieDiv>             
            </Styled.LabelDiv>
          </Styled.StatsBox>
        </Link>

        </Styled.StatsDiv>

        <Styled.GraphDiv>
          
          <Styled.GraphDivLeft>
            <Styled.GraphDivLabelDiv>
              <Styled.LabelHeading> Active Customers - Analysis </Styled.LabelHeading>

              <Styled.GraphMonthSelector>
                Last 12 months
              </Styled.GraphMonthSelector>
            
            </Styled.GraphDivLabelDiv>

            {graphLoader ?
              <div style={{ height: '25vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
                <Spin />
              </div>
            :
              <ResponsiveContainer width="100%" height="80%">
                <LineChart
                  width={500}
                  height={300}
                  data={graphData}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis 
                    dataKey="month"
                    tickFormatter={(value) => moment(value, "MMMM YYYY").format("MMM")}
                  />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey="active customers" stroke="rgb(30 124 10)" name="Active Customers" />
                </LineChart>
              </ResponsiveContainer>
            }
          </Styled.GraphDivLeft>
          <span></span>

          <Styled.GraphDivRight style={{alignItem: 'center'}}>

            <Styled.GraphDivLabelDiv>
              <Styled.LabelHeading> Lead Pipeline </Styled.LabelHeading>
            </Styled.GraphDivLabelDiv>

            {
              leadCount > 0 ?              
                <Styled.PieDiv>
                              
                  <div style={{position: 'relative'}}>
                    <PieChart width={200} height={200}>
                      <Pie
                        data={pieGraphData}
                        innerRadius={60}
                        // outerRadius={80}
                        fill="#8884d8"                        
                        dataKey="value"
                      >
                        {pieGraphData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                    </PieChart>
                    <Styled.TotalAmount> {leadCount} </Styled.TotalAmount>
                  </div>                              
              
                  <Styled.PieDivInfo>
                    {
                      pieGraphData.sort((a,b)=> b.value - a.value).map((item,index)=>(
                        <Styled.InfoRow>
                          <Styled.InfoColor style={{backgroundColor: COLORS[index % COLORS.length]}} />
                          <Styled.InfoLabel> {item.name} - {item.value}</Styled.InfoLabel>
                        </Styled.InfoRow>
                      ))
                    }  
                  </Styled.PieDivInfo>
              
                </Styled.PieDiv>
              :
               <Empty style={{marginTop: '10%'}} description = {<span style={{color: 'grey', fontSize: 'small'}}> data not available </span>} />
            }
              <Styled.ArrowContainer>
                <Link to="/lead-pipeline">
                  <Styled.ViewMoreButton>    
                    View More
                    <ArrowRightOutlined style={{fontSize: 'large',cursor: 'pointer'}}/>
                  </Styled.ViewMoreButton>   
                </Link>  
              </Styled.ArrowContainer>
            </Styled.GraphDivRight>

        </Styled.GraphDiv>
        

      </Styled.MainContainer>
    </Spin>
  );
}

export default Dashboard;